import * as tslib_1 from "tslib";
import { SelectionModel } from '@angular/cdk/collections';
import { OnDestroy, OnInit, } from '@angular/core';
import { UiModalComponent } from '@components/ui-modal/ui-modal.component';
import { TranslateService } from '@ngx-translate/core';
import { ModalService, ODataQueryOptions, ProcessService, } from '@services';
import { BehaviorSubject, Subject, } from 'rxjs';
import { filter, finalize, takeUntil, } from 'rxjs/operators';
var ProcessVersionViewMode;
(function (ProcessVersionViewMode) {
    ProcessVersionViewMode[ProcessVersionViewMode["Processes"] = 0] = "Processes";
    ProcessVersionViewMode[ProcessVersionViewMode["ReleaseNotes"] = 1] = "ReleaseNotes";
})(ProcessVersionViewMode || (ProcessVersionViewMode = {}));
var NugetUpgradeModalComponent = /** @class */ (function (_super) {
    tslib_1.__extends(NugetUpgradeModalComponent, _super);
    function NugetUpgradeModalComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.ProcessVersionViewMode = ProcessVersionViewMode;
        _this.processService = _this._injector.get(ProcessService);
        _this.loading$ = new BehaviorSubject(true);
        _this.submitting$ = new BehaviorSubject(false);
        _this.selection = new SelectionModel(true);
        _this.totalPackagesToUpgrade = 0;
        _this._destroyed$ = new Subject();
        _this._modalService = _this._injector.get(ModalService);
        _this._translateService = _this._injector.get(TranslateService);
        _this.processLabel = function (process) {
            return "v" + process.processVersion + " \u2013 " + process.environmentName;
        };
        _this._getPackage = function (id) {
            return _this.packageList.find(function (packageItem) { return packageItem.id === id; });
        };
        return _this;
    }
    NugetUpgradeModalComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.packageList = this.context.additionalData.packages.map(function (p) { return ({
            id: p.id,
            version: p.version,
            processes: [],
        }) || []; });
        var filterOptions = this.context.additionalData.packages.map(function (p) { return ({
            ProcessKey: p.id,
        }) || []; });
        var queryOptions = {
            orderBy: ['ProcessVersion desc'],
            filter: {
                or: filterOptions,
            },
        };
        this.processService
            .get(queryOptions)
            .pipe(finalize(function () { return _this.loading$.next(false); }), filter(function (_a) {
            var data = _a.data;
            return !!data;
        }), takeUntil(this._destroyed$))
            .subscribe(function (_a) {
            var data = _a.data;
            return data.forEach(function (process) {
                var pkg = _this._getPackage(process.processKey);
                if (!pkg) {
                    return;
                }
                _this.totalPackagesToUpgrade += 1;
                pkg.processes.push(process);
            });
        });
    };
    NugetUpgradeModalComponent.prototype.ngOnDestroy = function () {
        this.loading$.complete();
        this._destroyed$.next();
        this._destroyed$.complete();
    };
    NugetUpgradeModalComponent.prototype.checkedAll = function (packageId) {
        var _this = this;
        var pkg = this._getPackage(packageId);
        return pkg.processes.every(function (p) { return _this.selection.isSelected(p); });
    };
    NugetUpgradeModalComponent.prototype.indeterminate = function (packageId) {
        var _this = this;
        var pkg = this._getPackage(packageId);
        return pkg.processes.some(function (p) { return _this.selection.isSelected(p); }) &&
            !pkg.processes.every(function (p) { return _this.selection.isSelected(p); });
    };
    NugetUpgradeModalComponent.prototype.toggleAll = function (checkbox, packageId) {
        var _a, _b;
        var pkg = this._getPackage(packageId);
        checkbox.checked ? (_a = this.selection).select.apply(_a, pkg.processes) : (_b = this.selection).deselect.apply(_b, pkg.processes);
    };
    NugetUpgradeModalComponent.prototype.onUpgradeVersion = function () {
        var _this = this;
        if (this.selection.isEmpty()) {
            return;
        }
        var promptMessage = this._translateService.instant('package_upgrade_upgrade_confirmation');
        this._modalService.onConfirm(null, function () {
            _this.submitting$.next(true);
            var selectedKeys = _this.selection.selected.map(function (r) { return r.id; });
            _this.processService.updateReleasesToLatestVersionBulk(selectedKeys)
                .pipe(finalize(function () {
                _this.submitting$.next(false);
            }))
                .subscribe(function () {
                _this._dialogRef.close({
                    type: 2 /* Update */,
                });
            });
        }, function () { }, promptMessage);
    };
    return NugetUpgradeModalComponent;
}(UiModalComponent));
export { NugetUpgradeModalComponent };
